import { useContext } from 'react';
import { ProductContext } from "./ProductCard";

import styles from '../styles/styles.module.css'


export interface Props {
    className?: string
    moneda?: string,
    activeClass?: string;
    style?: React.CSSProperties
}

export const ProductMoneda = ({ moneda, className, style }: Props) => {

    const { product } = useContext(ProductContext)
    return (
        <span
            className={`${styles.productDescription} ${className}`}
            style={style}
        >
            {moneda ? moneda : product.moneda}
        </span>
    );
}